import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const PlanCardGridContainer = styled.div`
    container-type: inline-size;
    container-name: plans-grid;
`;

export const StyledPlanCardGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr auto;
    row-gap: 0; /* Because of subgrid row-gap is implemented using margins */
    column-gap: ${getPurpurSpacing('200')};
    & > * {
        margin-bottom: ${getPurpurSpacing('200')};
        &:last-child {
            margin-bottom: 0;
        }
    }

    @container plans-grid (min-width: 54rem) {
        grid-template-columns: repeat(2, 1fr);

        /* 2 items in last row */
        &:has(> :last-child:nth-child(2n)) > :nth-last-child(-n + 2) {
            margin-bottom: 0;
        }
    }

    @container plans-grid (min-width: 72rem) {
        grid-template-columns: repeat(3, 1fr);
        column-gap: ${getPurpurSpacing('300')};
        & > *,
        /* Reset tablet style */
        &:has(> :last-child:nth-child(2n)) > :nth-last-child(-n + 2) {
            margin-bottom: ${getPurpurSpacing('300')};
        }

        /* 2 items in last row */
        &:has(> :last-child:nth-child(3n + 2)) > :nth-last-child(-n + 2) {
            margin-bottom: 0;
        }

        /* 3 items in last row */
        &:has(> :last-child:nth-child(3n)) > :nth-last-child(-n + 3) {
            margin-bottom: 0;
        }
    }
`;
